import { differenceInWeeks, intervalToDuration, parseISO } from 'date-fns'

export interface Age {
  seconds: number
  minutes: number
  hours: number
  days: number
  months: number
  years: number
  ageInMonths: number
}

export function calculateAge(birthDate: string | number, refDate: string | number = Date.now()): Age {
  const endDate = refDate || Date.now()
  const interval = intervalToDuration({
    start: isString(birthDate) ? parseISO(birthDate) : birthDate,
    end: isString(endDate) ? parseISO(endDate) : endDate,
  })

  let { years, months, days } = interval
  const { hours, minutes, seconds } = interval

  if (days > 30) {
    months += Math.floor(days / 31)
    days = days % 31
  }
  if (months > 11) {
    years += Math.floor(months / 12)
    months = months % 12
  }

  const ageInMonths = 12 * years + months

  return { years, months, days, hours, minutes, seconds, ageInMonths }
}

export function calculateAgeInWeeks(birthDate: string | number, referenceDate: string | number = Date.now()) {
  const startDate = typeof birthDate === 'string' ? parseISO(birthDate) : birthDate
  const endDate = typeof referenceDate === 'string' ? parseISO(referenceDate) : referenceDate

  return differenceInWeeks(endDate, startDate)
}

function isString(x: any): x is string {
  return typeof x === 'string'
}

export function monthsToYearsFloor(months: number): number {
  return Math.floor(months / 12)
}
